// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"f1ccf5a5","663":"58565b07"}[chunkId] + ".chunk.js";
};